import {
    apiRequest,
    kriteriaSkpTunkinDetail
} from "../../../../../services/adapters/kepegawaian/kriteriaSkpTunkinService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", kriteriaSkpTunkinDetail, {
            params: query
        }, true)
    }
}

export default DetailRepository